import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { FontSizes } from '../../../types/common/types';
import { ButtonColors } from '../../../ui/gzButton/types';

export const templateMdrCustomerPanel = document.createElement('template');

templateMdrCustomerPanel.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div id='sso-infobox-wrapper' class='hidden' slot='grid-header-infobox-slot'>
      <gz-info-box severity='warning' class='mb-2' id='sso-disabled'></gz-info-box>
  </div>
  <gz-banner class='wrapper'>
    <div id='mdr-logo'></div>
    <gz-text id='mdr-text' fontSize='${FontSizes.HEADING_6}'></gz-text>
    <div id='mdr-container'>
      <div id='mdr-license-info'>
        <gz-labeled-content id='mdr-subscription-type' labelfontsize='14' hasColon='true' hasFormLabelWidth='true'></gz-labeled-content>
        <gz-labeled-content id='mdr-start-end-date' labelfontsize='14' hasColon='true' hasFormLabelWidth='true'></gz-labeled-content>
        <gz-labeled-content id='mdr-status' labelfontsize='14' hasColon='true' hasFormLabelWidth='true'></gz-labeled-content>
      </div>
      <div id='mdr-warranty-info'>
        <gz-labeled-content id='mdr-warranty-type' labelfontsize='14' hasColon='true' hasFormLabelWidth='true'></gz-labeled-content>
        <gz-labeled-content id='mdr-warranty-end-date' labelfontsize='14' hasColon='true' hasFormLabelWidth='true'></gz-labeled-content>
        <gz-labeled-content id='mdr-warranty-status' labelfontsize='14' hasColon='true' hasFormLabelWidth='true'></gz-labeled-content>
      </div>
    </div>
    <gz-button id='open-console-button' color='${ButtonColors.PRIMARY}'></gz-button>
    <gz-info-box severity='warning' class='mb-2' id='license-expiration-info'></gz-info-box>
  </gz-banner>
`;
